/* eslint-disable react/no-array-index-key */
import React from 'react'

import { CallToUsButtonComponent, Image, Logo, Nav } from '../../components'
import LinkComponent from '../../components/LinkComponent/LinkComponent'
import { useFooterData } from '../../hooks/useFooterData'
import { useHeaderData } from '../../hooks/useHeaderData'
import { useTreatmentCategories } from '../../hooks/useTreatmentCategories'
import { defaultLanguage } from '../../utils/appConfig'
import { ContentParser, sortArrayByAnotherArray } from '../../utils/helpers'
import {
  categoryLinks,
  categoryTitle,
  divider,
  extraMargin,
  footerBottom,
  footerBottomBar,
  footerBottomContent,
  footerCategoriesData,
  footerColumn,
  footerContainer,
  footerContentContainter,
  footerSocialLinks,
  linkSize,
  navContainer,
  navContentContainer,
  socialContentStyling,
  socialIconsStyling,
  socialLabelStyling,
  socialTitle,
} from './FooterContainer.module.css'

const FooterContainer = ({ pageContext }) => {
  const { lang: currentLang } = pageContext
  const data = useHeaderData().filter(
    (item) => item.language.slug === currentLang.slice(0, 2),
  )

  const footerData = useFooterData().filter(
    (item) => item.language.slug === currentLang.slice(0, 2),
  )
  const {
    contenttypes: {
      header: { cta, staticlinks, treatments },
    },
  } = data[0]
  const {
    contenttypes: {
      footer: {
        addresslabel,
        addresstext,
        emailaddress,
        emaillabel,
        footermaincategories,
        generallinks,
        generallinkslabel,
        sociallabel,
      },
    },
  } = footerData[0]
  const treatmentsLinks = ContentParser(treatments, 'treatment')
  const staticItemLinks = ContentParser(staticlinks, 'link')
  const generalFooterLinks = ContentParser(generallinks, 'generallink')
  const socialIcons = ContentParser(
    footerData[0].contenttypes.footer,
    'socialicon',
  )
  const treatmentsAltData = useTreatmentCategories().filter(
    (item) => item.language.slug === currentLang.slice(0, 2),
  )
  const { treatmentcategorycontent } = treatmentsAltData[0]
  const treatmentAltCategories = ContentParser(
    treatmentcategorycontent,
    'treatmentcategory',
  ).filter((res) => res.treatments !== null)
  const mainAltCategories = treatmentAltCategories.filter(
    (res) => res.isundercategory === null,
  )
  const subAltCategories = treatmentAltCategories.filter(
    (res) => res.isundercategory !== null,
  )
  let ctaContent = cta
  if (typeof cta === 'string') {
    ctaContent = JSON.parse(cta)
  }

  return (
    <div className={footerContainer}>
      <div className={footerContentContainter}>
        <Logo extraClassName={extraMargin} />
        <div className={navContentContainer}>
          <Nav
            activeTreatment=""
            additionalClassName={linkSize}
            changed={false}
            currentLang={currentLang.slice(0, 2)}
            defaultLang={defaultLanguage === currentLang}
            extraClassName={navContainer}
            footerSection
            mainCategories={[]}
            onClick={() => {}}
            onMouseOver={() => {}}
            staticItemLinks={staticItemLinks
              .slice(3)
              .map((item) => item.nodes[0])}
            subCategories={[]}
            treatmentsData={[]}
            treatmentsLinks={treatmentsLinks}
          />
          {cta && <CallToUsButtonComponent cta={ctaContent} desktop />}
        </div>
      </div>
      <div className={footerCategoriesData}>
        {!!subAltCategories.length &&
          sortArrayByAnotherArray(subAltCategories, footermaincategories).map(
            (category, index) => {
              return (
                <div key={index} className={footerColumn}>
                  <p className={categoryTitle}>{category.heading}</p>
                  <ul>
                    {category.treatments.nodes.map(
                      (treatment, treatmentIndex) => {
                        const name = treatment.pageType.name
                          ? treatment.pageType.name
                          : treatment.title
                        const link =
                          defaultLanguage === currentLang
                            ? `/${treatment.pageType.uri}/`
                            : `/${currentLang.slice(0, 2)}/${
                                treatment.pageType.uri
                              }/`
                        return (
                          <li key={treatmentIndex}>
                            <LinkComponent className={categoryLinks} src={link}>
                              {name}
                            </LinkComponent>
                          </li>
                        )
                      },
                    )}
                  </ul>
                </div>
              )
            },
          )}
        {!!mainAltCategories.length &&
          mainAltCategories.map((category, index) => {
            return (
              <div key={index} className={footerColumn}>
                <p className={categoryTitle}>{category.heading}</p>
                <ul>
                  {category.treatments.nodes.map((treatment, categoryIndex) => {
                    const name = treatment.pageType.name
                      ? treatment.pageType.name
                      : treatment.title
                    const link =
                      defaultLanguage === currentLang
                        ? `/${treatment.pageType.uri}/`
                        : `/${currentLang.slice(0, 2)}/${
                            treatment.pageType.uri
                          }/`
                    return (
                      <li key={categoryIndex}>
                        <LinkComponent className={categoryLinks} src={link}>
                          {name}
                        </LinkComponent>
                      </li>
                    )
                  })}
                </ul>
              </div>
            )
          })}
        <div className="">
          <p className={categoryTitle}>{generallinkslabel}</p>
          <ul>
            {generalFooterLinks
              .map((item) => item.nodes[0])
              .map((link, linkIndex) => {
                const url =
                  defaultLanguage === currentLang
                    ? `/${link.pageType.uri}/`
                    : `/${currentLang.slice(0, 2)}/${link.pageType.uri}/`
                const name = link.pageType.name
                  ? link.pageType.name
                  : link.title
                return (
                  <li key={linkIndex}>
                    <LinkComponent className={categoryLinks} src={url}>
                      {name}
                    </LinkComponent>
                  </li>
                )
              })}
          </ul>
        </div>
      </div>
      <div className={footerBottom}>
        <div className={divider} />
        <div className={footerBottomContent}>
          <div className={footerSocialLinks}>
            <p className={`${socialLabelStyling} ${socialTitle}`}>
              {sociallabel}
            </p>
            <div className={socialIconsStyling}>
              {socialIcons.map((icon, iconIndex) => {
                const { iconurl } = icon
                return (
                  <div key={iconIndex}>
                    <a href={iconurl} rel="noreferrer" target="_blank">
                      <Image
                        alt={`Socialmedia icon ${iconIndex + 1}`}
                        src={icon?.icon?.node.localFile.childImageSharp}
                      />
                    </a>
                  </div>
                )
              })}
            </div>
          </div>
          <div>
            <p className={socialLabelStyling}>{emaillabel}</p>
            <a className={socialContentStyling} href={`mailto:${emailaddress}`}>
              {emailaddress}
            </a>
          </div>
          <div>
            <p className={socialLabelStyling}>{addresslabel}</p>
            <p className={socialContentStyling}>{addresstext}</p>
          </div>
        </div>
      </div>
      <div className={footerBottomBar}>
        <p>© Copyright {new Date().getFullYear()} </p>
        <p> ESSENTIAL AESTHETICS </p>
        <span>|</span>
        <p>All rights reserved</p>
      </div>
    </div>
  )
}

export default FooterContainer
